var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#C4E3FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1434:28885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0718 22.5919L35.7415 24.2616L19.2993 40.7038H17.6296V39.0342L34.0718 22.5919ZM40.6052 11.6667C40.1515 11.6667 39.6796 11.8482 39.3348 12.193L36.0137 15.5142L42.8193 22.3197L46.1404 18.9986C46.8481 18.2908 46.8481 17.1475 46.1404 16.4397L41.8937 12.193C41.5307 11.8301 41.077 11.6667 40.6052 11.6667ZM34.0718 17.456L14 37.5279V44.3334H20.8056L40.8774 24.2616L34.0718 17.456Z",
    fill: "#0091FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1434:28885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.3333,
    height: 51.3333,
    fill: "white",
    transform: "translate(4.66669)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.8449448dffb06295fa4591cf4d437ba4.svg";
export { ForwardRef as ReactComponent };